import { ref } from "vue";
export const toasts = ref<
  { id: number; text: string; action?: () => void; actionLabel?: string }[]
>([]);
let id = 0;
export function toast(
  text: string,
  action?: () => void,
  actionLabel = "Desfazer",
) {
  const current = ++id;
  toasts.value.push({ id: current, text, action, actionLabel });
  setTimeout(() => dismiss(current), 4500);
}
export function dismiss(id: number) {
  toasts.value = toasts.value.filter((t) => t.id !== id);
}
